export const None = 0
export const Ctrl = 1
export const Alt = 2
